const comefromConfig = {
  dev: {
    // 3.0健康平台
    health: {
      name: "health", //第三方唯一标识符
      usercenter: "//dev.daishu-component.com/health/#/mine", // 个人中心
      home: "//dev.daishu-component.com/health/#/", // 首页,
      windowTitle: "健康管理平台",
      prefix: "//dev.daishu-component.com/"
    },
    // 口袋有福---微信钉钉小程序
    pocketInfirmarySystem: type => {
      return {
        type: type ? "dd-miniapp" : "wx-miniapp",
        name: "pocketInfirmarySystem", //第三方唯一标识符
        usercenter: "/pages/mine/index", // 个人中心
        home: "/pages/home/index", // 首页,
        windowTitle: "口袋有福",
        prefix: "",
        h5url:'https://life.daishujiankang.com/pocket/#/',
      };
    },
   
    // 团检入口
    tuanjian: {
      name: "tuanjian", //第三方唯一标识符
      usercenter: "//dev.daishu-component.com/health/#/mine", // 个人中心
      home: "//dev.tuanjian.com/common#/", // 首页
      windowTitle: "袋鼠健康",
      prefix: "//dev.tuanjian.com/common#/"
    },
    //合伙人 经纪人端
    partner: {
      name: "partner",
      home:
        "//dev.daishutijian.com/apps/frontend/project-agent/partner/stage/#/home",
      usercenter:
        "//dev.daishutijian.com/apps/frontend/project-agent/partner/stage/#/user-center",
      windowTitle: "健康管理平台",
      prefix: "//dev.daishutijian.com/apps/frontend/project-agent/partner/"
    },
    //合伙人 用户端端
    user: {
      name: "user",
      home:
        "//dev.daishutijian.com/apps/frontend/project-agent/user/h5/index.php",
      usercenter: "//dev.daishu-component.com/health/#/mine",
      windowTitle: "健康管理平台",
      prefix: "//dev.daishutijian.com/apps/frontend/project-agent/user/"
    }
  },
  test: {
    // 3.0健康平台
    health: {
      name: "health", //第三方唯一标识符
      usercenter: "//test.daishutijian.com/services_component1/health/#/mine", // 个人中心
      home: "//test.daishutijian.com/services_component1/health/#/", // 首页
      windowTitle: "健康管理平台",
      prefix: "//test.daishutijian.com/services_component3/"
    },
     // 口袋有福---微信钉钉小程序
     pocketInfirmarySystem: type => {
      return {
        type: type ? "dd-miniapp" : "wx-miniapp",
        name: "pocketInfirmarySystem", //第三方唯一标识符
        usercenter: "/pages/mine/index", // 个人中心
        home: "/pages/home/index", // 首页,
        windowTitle: "口袋有福",
        prefix: "",
        h5url:'https://life.daishujiankang.com/pocket/#/',
      };
    },
    // 团检入口
    tuanjian: {
      name: "tuanjian", //第三方唯一标识符
      usercenter: "//test.daishutijian.com/services_component1/health/#/mine", // 个人中心
      home: "//test.daishutijian.com/tuanjian1/public/#/", // 首页
      windowTitle: "袋鼠健康",
      prefix: "//test.daishutijian.com/tuanjian1/public/#/"
    },
    //合伙人 经纪人端
    partner: {
      name: "partner",
      home:
        "//test.daishutijian.com/tijian2/apps/frontend/project-agent/partner/stage#/home",
      usercenter:
        "//test.daishutijian.com/tijian2/apps/frontend/project-agent/partner/stage#/user-center",
      windowTitle: "健康管理平台",
      prefix:
        "//test.daishutijian.com/tijian2/apps/frontend/project-agent/partner/"
    },
    //合伙人 用户端端
    user: {
      name: "user",
      home:
        "//test.daishutijian.com/tijian2/apps/frontend/project-agent/user/h5/index.php",
      usercenter: "//test.daishutijian.com/services_component1/health/#/mine",
      windowTitle: "健康管理平台",
      prefix:
        "//test.daishutijian.com/tijian2/apps/frontend/project-agent/user/"
    }
  },
  apps: {
    // 3.0健康平台
    health: {
      name: "health", //第三方唯一标识符
      usercenter: `//${
        window.location.host
      }/daishu_component/public/health/#/mine`, // 个人中心
      home: `//${window.location.host}/daishu_component/public/health/#/`, // 首页
      windowTitle: "健康管理平台",
      prefix: `//${window.location.host}/daishu_component/public/`
    },
     // 口袋有福---微信钉钉小程序
     pocketInfirmarySystem: type => {
      return {
        type: type ? "dd-miniapp" : "wx-miniapp",
        name: "pocketInfirmarySystem", //第三方唯一标识符
        usercenter: "/pages/mine/index", // 个人中心
        home: "/pages/home/index", // 首页,
        windowTitle: "口袋有福",
        prefix: "",
        
        h5url:'https://www.fulizhushou.cn/pocket/#/',
      };
    },
    // 团检入口
    tuanjian: {
      name: "tuanjian", //第三方唯一标识符
      usercenter: `//apps.daishutijian.com/daishu_component/public/health/#/mine`, // 个人中心
      home: `//apps.daishutijian.com/company/public/common#/`, // 首页
      windowTitle: "袋鼠健康",
      prefix: `//apps.daishutijian.com/company/public/common#/` // 首页
    },
    //合伙人 经纪人端
    partner: {
      name: "partner",
      home:
        "//apps.daishutijian.com/frontend/project-agent/partner/stage/#/home",
      usercenter:
        "//apps.daishutijian.com/frontend/project-agent/partner/stage/#/user-center",
      windowTitle: "健康管理平台",
      prefix: `//apps.daishutijian.com/frontend/project-agent/partner/` // 前缀
    },
    //合伙人 用户端端
    user: {
      name: "user",
      home: "//apps.daishutijian.com/frontend/project-agent/user/h5/#/home",
      usercenter:
        "//apps.daishutijian.com/daishu_component/public/health/#/mine",
      windowTitle: "健康管理平台",
      prefix: `//apps.daishutijian.com/frontend/project-agent/user/` // 前缀
    }
  }
};

export default comefromConfig;
